<template>
  <el-config-provider :locale="zhCn">
    <div id="app">
      <router-view />
    </div>
  </el-config-provider>
</template>

<script>
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "dayjs/locale/zh-cn";
import dayjs from "dayjs";
export default {
  name: "App",
  data() {
    return {
      zhCn, // 关键：让模板可以获取到 zhCn 变量
    };
  },
  // 注册组件（你的代码中遗漏了组件注册，虽然部分环境可能自动注册，但显式注册更稳妥）
  components: {
    ElConfigProvider,
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
}
</style>

